export function formatBirthDate(dateString) {
  if (!dateString) return { month: "-", day: "-", year: "-" };

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return { month: "-", day: "-", year: "-" };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return {
    month: months[date.getMonth()],
    day: String(date.getDate()).padStart(2, "0"),
    year: date.getFullYear(),
  };
}

export function formatDate(dateString) {
  if (!dateString) return { month: "-", day: "-", year: "-" };

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return { month: "-", day: "-", year: "-" };

  return {
    month: String(date.getMonth() + 1).padStart(2, "0"),
    day: String(date.getDate()).padStart(2, "0"),
    year: date.getFullYear(),
  };
}
export function getEmployeeId(employee, users) {
  if (!employee || !employee.id) return "-";

  const user = users.find(
    (user) => user.employee && user.employee.id === employee.id
  );

  return user && user.employeeId ? user.employeeId : "-";
}
